/**
 * PC_SR_01 importing the api function calls
 */
import { useState, useEffect } from 'react';
import React from 'react';
import { postEmployeeSalaryRevisionInfo, getEmployeeSalaryRevisionInfoForm, getCurrentCTC } from '../service/DirectorAPI';
import moment from 'moment-timezone';
import { Upload, uploadBackend } from '../utils/Upload';
import { useRef } from 'react';
import Loader from '../StaticComponent/Loader';
import { OnlyNumberSpecialChar } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { encryptStorage } from '../constant';
import { getS3 } from '../utils/Download.js';

/**
 *
 *  PC_SR_01.1
 * SalaryRevision(props) this function return the HTML
 */
export function SalaryRevision(props) {
    /**
     * PC_SR_02 Declaring the state variables and objects
     */
    let dataObj = {
        id: '',
        CurrentCTC: '',
        RevisedCTC: '',
        ActiveDate: '',
        ApprisalComments: '',
        NextVisitDate:'',
        OfferUrl: '',
    };

    let validationFields = {
        CurrentCTC: '',
        RevisedCTC: '',
        ActiveDate: '',
        ApprisalComments: '',
        OfferUrl: '',
    };

    const [salaryRevisionData, setSalaryRevisionData] = useState(dataObj);
    const [message, setmessage] = useState(validationFields);
    const [pagemode, setpagemode] = useState('false');
    const [EmpId, setEmpId] = useState('');
    const [Emp_name, setEmpname] = useState('');
    const [Emp_domain, setEmpdomain] = useState('');
    const [submit, setSubmit] = useState('Save');
    const attachment = useRef();
    const [hideForm, setHideForm] = useState(true);
    let loginEmpId = encryptStorage.getItem('employeeId');
    let role = encryptStorage.getItem('role');

    const [attachmentState, setattachmentState] = useState('');
    const [attachmentValidation, setattachmentValidation] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [showUpload, setShowUpload] = useState(false);
    const [ctcRejex, setCtcRejex] = useState('');
    const [isRejexValid, setIsRejexValid] = useState(true);
    const [docUrl, setDocUrl] = useState('');
    let minDate = moment().add(1, 'days').format('YYYY-MM-DD');

    /**
     * PC_SR_03
     * useEffect method get invoked and make a selecteditarray() api call in edit mode
     */
    useEffect(() => {
        if (props.isSalaryFormClicked) {
            $('body').addClass('removeScroll');
            setHideForm(false);
            if (props.empId != undefined) {
                setEmpId(props.empId);
                setEmpname(props.emp_name);
                setEmpdomain(props.emp_domain);
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    setpagemode('true');
                    setSubmit('Update');
                } else {
                    setpagemode('false');
                    setSubmit('Save');
                }

                if (props.Id != undefined && props.Mode == 'Edit') {
                    let objedit = {
                        emp_id: props.empId,
                        id: props.Id,
                        reports_to: loginEmpId,
                        role: role,
                    };

                    selecteditarray(objedit);
                } else {
                    let objedit = {
                        emp_id: props.empId,
                    };
                    LoadCurrentCTC(objedit);
                }
            }
        }
    }, [props]);

    const getCurrentTimezone = () => {
        const timezoneOffset = new Date().getTimezoneOffset();
        if (timezoneOffset === -330) { // IST offset
            return 'Asia/Kolkata';
        } else if (timezoneOffset === 300 || timezoneOffset === 360) { // Central Time offset (standard and daylight saving)
            return 'America/Chicago';
        }
        return Intl.DateTimeFormat().resolvedOptions().timeZone; // Fallback to system timezone
    };
    const formatDateForTimezone = (dateString, timezone) => {
            if (!dateString) return '';
    
    // Parse the date string into a Moment object using the specified timezone.
    const date = moment.tz(dateString, timezone);
    
    // Output the date in 'YYYY-MM-DD' format adjusted to the timezone provided.
    return date.format('YYYY-MM-DD');
    };
    
    
    /**
     *
     * PC_SR_04 this function get the current ctc from the db
     */
    const LoadCurrentCTC = async (objedit) => {
        let EducationData = { emp_id: objedit.emp_id };
        let responsedata = await getCurrentCTC(EducationData);
        salaryRevisionData.CurrentCTC = responsedata?.data?.ResponseData[0][0]?.ctc ? responsedata.data.ResponseData[0][0].ctc : '';
        setSalaryRevisionData({ ...salaryRevisionData });
    };

    /**
     *
     * PC_SR_12 setstate the values into the state object and validating the ctc format
     */
    const OnChangeName = (e) => {
        e.preventDefault();
        var regexItem;
        var checkValid;

        if (e.target.name == 'RevisedCTC') {
            regexItem = new RegExp('^[.0-9]*$');
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                setCtcRejex('Enter a Valid CTC');
                setIsRejexValid(false);
            } else {
                setCtcRejex('');
                setIsRejexValid(true);
            }
        }
        let value = e.target.value;
        if (e.target.name === 'ActiveDate' || e.target.name === 'NextVisitDate') {
            const currentTimezone = getCurrentTimezone();
            value = formatDateForTimezone(value, currentTimezone);
        }

        setSalaryRevisionData({ ...salaryRevisionData, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: '' });
    };
    /**
     *
     * PC_SR_11.1 this function catch the file details and
     * post it into the s3 bucket
     */
    const fileUpload = async (ref) => {
        let dirName = `${EmpId}-Salary_offerHr_${props.count}`;

        setIsLoading(false);
        let file = attachment.current.files[0];
        if (file !== undefined && file != null) {
            let newFileName = attachment.current.files[0].name;
            if (newFileName !== undefined && newFileName != null) {
                let fileLocation = await uploadBackend(file, newFileName, dirName);
                return fileLocation;
            } else {
                setIsLoading(true);
            }
        } else {
            setIsLoading(true);
        }
    };

    /**
     * PC_SR_13 this functiom perform the null check and set the error message
     */
    const validation = () => {
        if (salaryRevisionData.CurrentCTC == '') {
            message.CurrentCTC = 'Current CTC is required';
            setmessage({ ...message });
        } else {
            message.CurrentCTC = '';
            setmessage({ ...message });
        }
        if (salaryRevisionData.RevisedCTC == '') {
            message.RevisedCTC = 'Revised CTC is required';
            setmessage({ ...message });
        } else {
            message.RevisedCTC = '';
            setmessage({ ...message });
        }
        if (salaryRevisionData.ActiveDate == '') {
            message.ActiveDate = 'Active Date is required';
            setmessage({ ...message });
        } else {
            message.ActiveDate = '';
            setmessage({ ...message });
        }
        if (salaryRevisionData.ApprisalComments == '') {
            message.ApprisalComments = 'Appraisal Comment is required';
            setmessage({ ...message });
        } else {
            message.ApprisalComments = '';
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(salaryRevisionData.ApprisalComments);
            if (checkregex) {
                message.ApprisalComments = 'Enter a Valid Comments';
                setmessage({ ...message });
            } else {
                message.ApprisalComments = '';
                setmessage({ ...message });
            }
        }

        if (salaryRevisionData.OfferUrl == '') {
            if (attachmentState == '') {
                message.OfferUrl = 'Attachment is Required';
                setmessage({ ...message });
            } else {
                message.OfferUrl = '';
                setmessage({ ...message });
            }
        } else {
            if (salaryRevisionData.OfferUrl == '') {
                message.OfferUrl = 'Attachment is Required';
                setmessage({ ...message });
            } else {
                message.OfferUrl = '';
                setmessage({ ...message });
            }
        }
    };

    /**
     * PC_SR_11.2 this function validate the file size and format
     */
    const bindAttachName = (e) => {
        setattachmentValidation('');
        message.OfferUrl = '';
        setmessage({ ...message });
        setShowUpload(true);
        setattachmentState(e.target.files[0].name);

        if (e.target.files[0].size >= 1000000) {
            setattachmentValidation('File size should be less than 1MB');
            attachment.current.value = '';
            return false;
        }
        const typeArr = ['pdf'];
        let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
        if (type == false) {
            setattachmentValidation('The uploaded file should be in PDF format');
            attachment.current.value = '';
            return false;
        }
    };

    /**
     * PC_SR_11.3 this function remove the file details from the variable
     */
    const removeCertificate = () => {
        setattachmentState('');
        setattachmentValidation('');
        setShowUpload(false);
    };

    /**
     * PC_SR_20.1 this function set the emplty values from the objects
     */
    const cancelClick = () => {
        let validationFields = {
            CurrentCTC: '',
            RevisedCTC: '',
            ActiveDate: '',
            ApprisalComments: '',
            NextVisitDate:'',
            OfferUrl: '',
        };
        setmessage(validationFields);

        let valiclearoption = {
            id: '',
            CurrentCTC: '',
            RevisedCTC: '',
            ActiveDate: '',
            ApprisalComments: '',
            NextVisitDate:'',
            OfferUrl: '',
        };
        setSalaryRevisionData(valiclearoption);
        props.setIsSalaryFormcliclk(false);
        setattachmentState('');
        setShowUpload(false);
        setHideForm(true);
        $('body').removeClass('removeScroll');
    };

    /**
     * PC_SR_11.3 this function remove the file details from the variable
     */
    const removeOffer = () => {
        salaryRevisionData.OfferUrl = '';
        setSalaryRevisionData({ ...salaryRevisionData });
        setattachmentState('');
        setShowUpload(false);
    };

    /**
     * PC_SR_20 this function post the data into the db for specific emp_id
     */
    const submitClick = async () => {
        try {
            validation();

            let isValid = true;
            if (message.ApprisalComments != '') {
                isValid = false;
            }
            //let nextdate= salaryRevisionData.NextVisitDate? salaryRevisionData.NextVisitDate:null
            const timezone = 'America/Chicago';

        // Format ActiveDate and NextVisitDate using formatDateForTimezone before submission
            //  const activeDateFormatted = formatDateForTimezone(salaryRevisionData.ActiveDate, timezone);
            // const nextVisitDateFormatted = formatDateForTimezone(salaryRevisionData.NextVisitDate, timezone);


            if (pagemode == 'false' && isRejexValid == true && isValid == true) {
                if (
                    salaryRevisionData.CurrentCTC != '' &&
                    salaryRevisionData.RevisedCTC != '' &&
                    salaryRevisionData.ActiveDate != '' &&
                    salaryRevisionData.ApprisalComments != '' &&
                    message.OfferUrl == '' &&
                    attachmentValidation == ''
                ) {
                    let activeDateFormatted = salaryRevisionData.ActiveDate;
                    // moment.tz(salaryRevisionData.ActiveDate, timezone).startOf('day').utcOffset(0, true).format();
                    let nextVisitDateFormatted = salaryRevisionData.NextVisitDate 
                        ? salaryRevisionData.NextVisitDate
                        // moment.tz(salaryRevisionData.NextVisitDate, timezone).startOf('day').utcOffset(0, true).format()
                        : null;
                    let offerletterURL = await fileUpload();
                    let insertdata = {
                        request_type: 'Insert',
                        emp_id: EmpId,
                        login_emp_id: loginEmpId,
                        role: role,
                        current_ctc: salaryRevisionData.CurrentCTC,
                        revised_ctc: salaryRevisionData.RevisedCTC,
                        active_from: activeDateFormatted,
                        apprisal_comments: salaryRevisionData.ApprisalComments,
                        next_visit_date: nextVisitDateFormatted,
                        offer_attach_url: offerletterURL,
                    };

                    let responsedata = await postEmployeeSalaryRevisionInfo(insertdata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            id: '',
                            CurrentCTC: '',
                            RevisedCTC: '',
                            ActiveDate: '',
                            ApprisalComments: '',
                            NextVisitDate:'',
                            OfferUrl: '',
                        };
                        setSalaryRevisionData(valiclearoption);
                        props.setIsSalaryFormcliclk(false);
                        props.loadsalaryRevision();
                        setattachmentState('');
                        setShowUpload(false);
                        setIsLoading(true);
                        cancelClick();
                    }
                }
            } else if (pagemode == 'true' && isRejexValid == true && isValid == true) {
                if (
                    salaryRevisionData.CurrentCTC != '' &&
                    salaryRevisionData.RevisedCTC != '' &&
                    salaryRevisionData.ActiveDate != '' &&
                    salaryRevisionData.ApprisalComments != '' &&
                    message.OfferUrl == '' &&
                    attachmentValidation == ''
                ) {
                    let activeDateFormatted = salaryRevisionData.ActiveDate
                    // moment.tz(salaryRevisionData.ActiveDate, timezone).startOf('day').utcOffset(0, true).format();
                    let nextVisitDateFormatted = salaryRevisionData.NextVisitDate 
                        ?salaryRevisionData.NextVisitDate
                        //  moment.tz(salaryRevisionData.NextVisitDate, timezone).startOf('day').utcOffset(0, true).format()
                        : null;
                    let offerletterURL = await fileUpload();
                    let updatedata = {
                        request_type: 'Update',
                        emp_id: EmpId,
                        login_emp_id: loginEmpId,
                        role: role,
                        id: salaryRevisionData.id,
                        current_ctc: salaryRevisionData.CurrentCTC,
                        revised_ctc: salaryRevisionData.RevisedCTC,
                        active_from: activeDateFormatted,
                        next_visit_date: nextVisitDateFormatted,
                        apprisal_comments: salaryRevisionData.ApprisalComments,
                        offer_attach_url: offerletterURL == undefined ? salaryRevisionData.OfferUrl : offerletterURL,
                    };

                    let responsedata = await postEmployeeSalaryRevisionInfo(updatedata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            id: '',
                            CurrentCTC: '',
                            RevisedCTC: '',
                            ActiveDate: '',
                            ApprisalComments: '',
                            OfferUrl: '',
                            NextVisitDate:''

                        };

                        setSalaryRevisionData(valiclearoption);

                        props.setIsSalaryFormcliclk(false);
                        props.loadsalaryRevision();
                        setattachmentState('');
                        setShowUpload(false);
                        setIsLoading(true);
                        cancelClick();
                    }
                }
            }
        } catch (e) {
            setIsLoading(true);
        }
    };

    /**
     * PC_SR_24 this function get the datas from the db snd set setsate into the objects.
     */
    const selecteditarray = async (objedit) => {
        try {
            let responsedata = await getEmployeeSalaryRevisionInfoForm(objedit);
            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {
                // let ActiveFrom = moment(new Date(responsedata.data.ResponseData[0][0].active_from));
                // let activefrom = ActiveFrom.format('YYYY-MM-DD');
                
                // let nextVisitDateValue = responsedata.data.ResponseData[0][0].next_visit_date;
                // let nextvisitdate = nextVisitDateValue != null ? moment(new Date(nextVisitDateValue)).format('YYYY-MM-DD') : null;                // let NextVisitDate = moment(new Date(responsedata.data.ResponseData[0][0].next_visit_date));
                // let nextvisitdate = NextVisitDate.format('YYYY-MM-DD');
                const currentTimezone = getCurrentTimezone();
                const activefrom = formatDateForTimezone(responsedata.data.ResponseData[0][0].active_from);
                const nextvisitdate = responsedata.data.ResponseData[0][0].next_visit_date 
                ? formatDateForTimezone(responsedata.data.ResponseData[0][0].next_visit_date) : '';
                let valiDateobj1 = {
                    id: responsedata.data.ResponseData[0][0].id,
                    CurrentCTC: responsedata.data.ResponseData[0][0].current_ctc,
                    RevisedCTC: responsedata.data.ResponseData[0][0].revised_ctc,
                    ActiveDate: activefrom,
                    ApprisalComments: responsedata.data.ResponseData[0][0].apprisal_comments,
                    NextVisitDate:nextvisitdate,
                    OfferUrl: responsedata.data.ResponseData[0][0].offer_attach_url,
                };
                setSalaryRevisionData(valiDateobj1);

                if (responsedata.data.ResponseData[0][0].offer_attach_url != '') {
                    setShowUpload(true);
                }
            }
        } catch (e) { }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.8)' }} hidden={hideForm}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content p-3">
                    <Loader isLoading={isLoading} />

                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="SalaryRevisionPopupLabel">
                            {' '}
                            Salary Revision Form
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="modal-header border-0">
                        <div className="profile-left d-flex">
                            <div className="d-flex">
                                <img
                                    src="/Images/logo-person-user-person-icon.jpg"
                                    alt="User Profile Image"
                                    className="profile-image-feedback"
                                />
                            </div>
                            <div className="d-grid ms-3">
                                <span className="font-14 semibold-text team-member-name">{Emp_name}</span>
                                <span className="font-14 pb-0 pt-1 regular-text my-0">{Emp_domain}</span>
                            </div>
                        </div>
                    </div>

                    <div className="row modal-body border-0">
                        <div className="col-md-4">
                            <label className="form-label hive-form-label" htmlFor="department">
                                Current CTC <span className="hive-form-mandatory">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control hive-form-control"
                                id="people"
                                disabled
                                name="CurrentCTC"
                                value={salaryRevisionData.CurrentCTC}
                                onChange={(e) => {
                                    OnChangeName(e);
                                }}
                            />
                            <label className="hive-form-mandatory">{message.CurrentCTC}</label>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label hive-form-label" htmlFor="person-name">
                                Revised CTC <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control hive-form-control"
                                placeholder="Enter here"
                                id="people"
                                maxLength={5}
                                name="RevisedCTC"
                                value={salaryRevisionData.RevisedCTC}
                                onChange={(e) => {
                                    OnChangeName(e);
                                }}
                            />
                            {message.RevisedCTC ? <label className="hive-form-mandatory">{message.RevisedCTC}</label> : null}
                            {ctcRejex ? <label className="hive-form-mandatory">{ctcRejex}</label> : null}
                        </div>
                        <div className="col-md-4">
                            <label className="form-label hive-form-label" htmlFor="people">
                                Active Date <span className="required">*</span>
                            </label>
                            <input
                                type="date"
                                className="form-control hive-form-control"
                                id="passportdetails-expiry"
                                aria-describedby="Expiry"
                                // min={minDate}
                                name="ActiveDate"
                                value={salaryRevisionData.ActiveDate}
                                onChange={(e) => {
                                    OnChangeName(e);
                                }}
                            />
                            {message.ActiveDate ? <label className="hive-form-mandatory">{message.ActiveDate}</label> : null}
                        </div>
                        <div className="col-md-4">
                            <label className="form-label hive-form-label" htmlFor="people">
                                Next visit Date 
                            </label>
                            <input
                                type="date"
                                className="form-control hive-form-control"
                                id="passportdetails-expiry"
                                aria-describedby="Expiry"
                                min={minDate}
                                name="NextVisitDate"
                                value={salaryRevisionData.NextVisitDate}
                                onChange={(e) => {
                                    OnChangeName(e);
                                }}
                            />
                        </div>

                        <div className="col-md-6 mb-4">
                            <label htmlFor="certificate-upload" className="form-label hive-form-label">
                                Attachment<span className="hive-form-mandatory">*</span>
                                <span>
                                    <img
                                        className="ms-1"
                                        src="/Images/help.svg"
                                        title="Upload offer letter in pdf format and lessthan 1MB"
                                        alt="help-icon"
                                    />
                                </span>
                            </label>
                            <div className>
                                <div className="custom-upload-btn-wrapper" hidden={showUpload}>
                                    <label htmlFor="salary-Revision" className="goalform-custom-file-upload">
                                        <img className="me-2" src="Images/profile-upload-icon.svg" alt="Upload Icon" />
                                        Upload
                                    </label>

                                    <input
                                        id="salary-Revision"
                                        type="file"
                                        className="profile-file-upload"
                                        name="attachement_url"
                                        ref={attachment}
                                        onChange={(e) => bindAttachName(e)}
                                    />
                                    <label className="hive-form-mandatory" />
                                </div>

                                {attachmentState ? (
                                    <div>
                                        <a
                                            className="text-decoration-none "
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title={attachmentState}
                                        >
                                            <img src="/Images/profile-certificate-attachment.svg" alt="Attachment Icon" className="p-1" />
                                            {attachmentState.length > 20 ? attachmentState.substring(0, 20) : attachmentState}
                                        </a>
                                        <span>
                                            {' '}
                                            <img
                                                src="/Images/profile-certificate-cancel.svg"
                                                className="cursor-pointer"
                                                alt="Cancel Icon"
                                                onClick={() => removeCertificate()}
                                            />
                                        </span>
                                    </div>
                                ) : null}

                                {salaryRevisionData.OfferUrl ? (
                                    <div>
                                        <a
                                            style={{cursor:"pointer"}}
                                            className="text-decoration-none "
                                            onClick={async () => {

                                                window.open(await getS3(salaryRevisionData.OfferUrl), "_blank");
        
        
                                            }} 
                                            target="_blank"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title={salaryRevisionData.OfferUrl.substring(59)}
                                        >
                                            <img src="/Images/profile-certificate-attachment.svg" alt="Attachment Icon" className="p-1" />
                                            {salaryRevisionData.OfferUrl.substring(59).length > 20
                                                ? salaryRevisionData.OfferUrl.substring(59).substring(0, 20)
                                                : salaryRevisionData.OfferUrl.substring(59)}
                                        </a>
                                        <span>
                                            {' '}
                                            <img
                                                src="/Images/profile-certificate-cancel.svg"
                                                className="cursor-pointer"
                                                alt="Cancel Icon"
                                                onClick={() => removeOffer()}
                                            />
                                        </span>
                                    </div>
                                ) : null}

                                {message.OfferUrl ? <label className="hive-form-mandatory">{message.OfferUrl}</label> : null}
                                {attachmentValidation ? <label className="hive-form-mandatory">{attachmentValidation}</label> : null}
                            </div>
                        </div>

                        <div className="col-md-12 mb-4">
                            <label className="form-label hive-form-label" htmlFor="concern-description">
                                Appraisal Comments <span className="required">*</span>
                            </label>
                            <textarea
                                className="custom-comment-box hive-form-control custom-textfield form-control"
                                placeholder="Enter Here"
                                id="concern-description"
                                maxLength={225}
                                name="ApprisalComments"
                                value={salaryRevisionData.ApprisalComments}
                                onChange={(e) => {
                                    OnChangeName(e);
                                }}
                            />
                            {message.ApprisalComments ? <label className="hive-form-mandatory">{message.ApprisalComments}</label> : null}
                        </div>

                        <div className="modal-footer border-0">
                            <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn hive-btn-primary"
                                onClick={() => {
                                    //debugger
                                    submitClick();
                                }}
                            >
                                {submit}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SalaryRevision;
